<mat-card class="b-1 shadow-none">
  <mat-card-header>
    <mat-card-title>Administrar Usuarios</mat-card-title>
  </mat-card-header>
  <mat-card-content class="b-t-1">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Usuarios">
        <app-add-users
          *appRechargeUsers="eventReload"
          (changeComponent)="receiveMsg($event)"
        ></app-add-users>
      </mat-tab>
      <mat-tab label="Usuarios Eliminados">
        <app-deleted-users></app-deleted-users>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
